// This file is in its own module to be mocked in the tests

/**
 * Gets the dimensions of an image.
 * @param image - The image to get the dimensions of.
 * @returns The dimensions of the image (width and height)
 * @throws An error if the image is not a valid image.
 */
export async function getImageDimensions(image: File): Promise<{width: number; height: number}> {
    if (typeof window !== 'undefined') {
        const url = URL.createObjectURL(image);
        try {
            const img = new Image();
            return await new Promise<{width: number; height: number}>((resolve, reject) => {
                img.onload = () => resolve({width: img.width, height: img.height});
                img.onerror = reject;
                img.src = url;
            });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            URL.revokeObjectURL(url);
        }
    }
    return Promise.resolve({width: 0, height: 0});
}
/**
 * Server side friendly way of checking for a File
 * @param value - The value to check.
 * @returns True if the value is a File or FileList, false otherwise.
 */
export function isFile(value: unknown): value is File | FileList {
    return value?.constructor?.name === 'File' || value?.constructor?.name === 'FileList';
}
